import React, { useEffect, useState } from 'react'
import * as XLSX from 'xlsx';
import { Badge, Button, Spinner } from 'react-bootstrap'
import './../index.css'
import { MdSimCardDownload }  from "react-icons/md";
import ModalView from './ModalView'

export default function Table({title, data, studentIndexes, setStudents}) {


    const [showModal, setShowModal] = useState(false)

    const handleClose = () => setShowModal(false)

    const exportToExcel = () => {
        // Get table data here
        const tableData = [];
    
        // Select all the table rows
        const rows = document.querySelectorAll('table tr');
    
        // Loop through the rows and cells to populate the tableData array
        rows.forEach(row => {
          const rowData = [];
          const cells = row.querySelectorAll('td, th');
          cells.forEach(cell => {
            rowData.push(cell.innerText);
          });
          tableData.push(rowData);
        });
    
        // Create a new workbook
        const workbook = XLSX.utils.book_new();
    
        // Add a new worksheet
        const worksheet = XLSX.utils.json_to_sheet(tableData);
    
        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    
        // Export the workbook
        XLSX.writeFile(workbook, 'Registered_Students_Data.xlsx');
      }
    
  return (

    <div className="container-fluid">

        {/* <!-- Page Heading --> */}
        <h1 className="h3 mb-2 text-gray-800">  {title} </h1>
        <p className="mb-4"> جدول عرض طلبات تسجيل الطلبه لتتبع حالاتهم   </p>

        {/* <!-- DataTales Example --> */}
 
      <div className="card shadow mb-4" >
      {data.length &&
      <> 
            <div style={{justifyContent: "left"}} className="card-header py-3 d-flex justity-content-left" >
               <Button variant='success ' style={{width: '10rem', background:"#23641d"}}  onClick={exportToExcel}> تنزيل ملف .xlsx <MdSimCardDownload/> </Button>
            </div>
            <div className="card-body">
                <div className="table-responsive table-responsive-sm">
                    <table className="table  table-bordered" style={{color: 'rgb(241, 241, 241)'}} id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <tr>
                                 <th> # </th>
                                <th> رقم الدراسي </th>
                                <th>   البيانات  </th>
                                <th>  حالة الطلب  </th>
                                <th>  تاريخ التسجيل </th>
                                <th>  مقررات تم الموافقة عليها </th>
                              
                            </tr>
                        </thead>
                        <tbody>
                      
                        {data.length && data.map((studentName, i) => (
  <tr key={studentName?.student_id}>
    <td> {i + 1} </td>
    <td> {studentName?.student_id ? studentName?.student_id : "غير مسجل في المنصة"} </td> 
    <td> 
      {studentName?.updatedAt ? <ModalView setStudents={setStudents}  modalState={showModal} setModal={setShowModal} handleClose={handleClose} student={studentName.student_id} /> : "لم يسجل بعد " }
    </td>
    <td>
      {studentName?.status === "Approved" ?  
        <Badge bg="success"> مقبول </Badge> : 
        (studentName?.status === "Rejected" ?  
          <Badge bg="danger"> مرفوض </Badge> : 
          (studentName?.new_subjects.length && studentName?.status === "Pending" ? 
            <Badge bg="primary"> في انتظار موافقة المشرف </Badge> :
            <Badge text="dark" bg="warning"> قيد التسجيل </Badge> ))
      }
    </td>  
    <td>
      {studentName?.updatedAt ? new Date(studentName?.updatedAt?.seconds * 1000 + studentName?.updatedAt?.nanoseconds / 1000000).toLocaleDateString() : "Not Registered"}
    </td> 
    <td>
      {studentName?.status === "Approved" ? studentName?.new_subjects.join(',') : "لا يوجد"}
    </td> 
  </tr>
))}

                        </tbody>
                    </table>
                </div>
            </div>
  </>
            
            }
               {!data.length &&  <div style={{ display: "flex", padding: '10rem', justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>}
        </div>

    </div>
  )
}
